import logo from './logo.svg';
import Landing from './pages/landing';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Practice from './pages/prectice';
import Services from './pages/services';
import About from './pages/about';
import ScrollToTop from './components/scroll';
import Contact from './pages/contact';

function App() {
  return (
    <div className="App">
        <BrowserRouter>

        <ScrollToTop />
        <Routes>
          <Route path='/' element={<Landing/>} />
          <Route path='/practice-areas' element={<Practice/>} />
          <Route path='/services' element={<Services/>} />
          <Route path='/about' element={<About/>} />
          <Route path='/contact' element={<Contact/>} />
         </Routes>
         </BrowserRouter>
    </div>
  );
}


export default App;
